export default __webpack_public_path__ + "static/media/controlTools24.4743c904.svg";